define('lq/oop',[],function () {
	'use strict';

    var extend = function(subClass, superClass) {
        superClass = superClass || this;
        var F = function() { };
        F.prototype = superClass.prototype;
        subClass.prototype = new F();
        subClass.prototype.constructor = subClass;
        subClass.extend = extend;

        if (superClass.prototype.constructor === Object.prototype.constructor) {
            superClass.prototype.constructor = superClass;
        }
    };

    var makeExtendable = function (obj) {
        obj.extend = extend;
    };

    return {
        extend: extend,
        makeExtendable: makeExtendable
    };
});


